import { useState } from "react";
import useTranslator from "../../hooks/useTranslator";
import FreshFruitRunningTotals from "./components/FreshFruitRunningTotals";
import ColdRoomDataOverview from "./components/ColdRoomDataOverview";
import BiggestDaily from "./components/BiggestDaily";
import PackingMetricCards from "./components/PackingProcessing/PackingMetricCards";
import PackingShifts from "./components/PackingProcessing/PackingShifts";
import BrokeringDay from "./components/PackingProcessing/BrokeringDay";
import DashboardSection from "./components/DashboardSection";
import "./components/dashboard-sections.css";
import { getCurrentDate } from "../../helpers/Utils";

const Dashboard = () => {
  const { _t } = useTranslator();
  const [period, setPeriod] = useState("daily");
  const [packingDate, setPackingDate] = useState(getCurrentDate("YYYY-MM-DD"));

  // Set to true to preview shimmer loading state
  const isLoading = false;

  const periods = [
    { key: "daily",   label: _t("daily",   "Daily")   },
    { key: "weekly",  label: _t("weekly",  "Weekly")  },
    { key: "monthly", label: _t("monthly", "Monthly") },
  ];

  return (
    <div>
      <div className="db-header">
        <div className="db-header-title">
          <h2>{_t("dashboard_title", "Off The Tree Dashboard")}</h2>
          <p>{_t("dashboard_subtitle", "Real-time supply chain and maturity metrics overview")}</p>
        </div>
        <ul className="db-period-toggle">
          {periods.map((p) => (
            <li
              key={p.key}
              className={period === p.key ? "active" : ""}
              onClick={() => setPeriod(p.key)}
            >
              {p.label}
            </li>
          ))}
        </ul>
      </div>

      <DashboardSection title={_t("biggest_daily_title", "Biggest Daily")}>
        <BiggestDaily isLoading={isLoading} />
      </DashboardSection>

      <DashboardSection title={_t("fresh_fruit_running_totals_title", "Fresh Fruit Running Totals")}>
        <FreshFruitRunningTotals isLoading={isLoading} />
      </DashboardSection>

      <DashboardSection title={_t("cold_room_data_overview_title", "Cold + Room Data Overview")}>
        <ColdRoomDataOverview isLoading={isLoading} />
      </DashboardSection>

      <DashboardSection
        title={_t("packing_processing_title", "Packing & Processing")}
      >
        <PackingMetricCards isLoading={isLoading} />
        <PackingShifts isLoading={isLoading} />
        <BrokeringDay isLoading={isLoading} />
      </DashboardSection>
    </div>
  );
};

export default Dashboard;
